import { map } from 'ramda';
import React, { FC, useState } from 'react';
import styled from 'styled-components';

import AnimatedNavWrapper from '@ui/atoms/AnimatedNavWrapper';
import FlexColumn from '@ui/atoms/FlexColumn';

import ProfileCard from '@ui/molecules/ProfileCard';
import ProfileLink from '@ui/molecules/ProfileLink';

import { CardContent } from '@folx-types/dashboard';

import theme from '@theme/FolxTheme';

export interface IProfileDropdownProps {
	links: CardContent[];
	name: string;
	className?: string;
}

const ProfileWrapper = styled(FlexColumn)`
	position: relative;
	width: fit-content;
`;

const NavMenu = styled(AnimatedNavWrapper)`
	position: absolute;
	top: ${theme.spacing.xl};
	right: 0;
	z-index: ${theme.zIndexes.foreground};
`;

export const ProfileLinks: FC<{ links: IProfileDropdownProps['links'] }> = ({ links }) =>
	map((link) => {
		return (
			<li key={link.pathName} role="presentation">
				<ProfileLink Icon={link.Icon} header={link.header} pathName={link.pathName} />
			</li>
		);
	}, links);

const ProfileDropdown: FC<IProfileDropdownProps> = ({ className, links, name }) => {
	const [open, setOpen] = useState(false);

	return (
		<ProfileWrapper className={className}>
			<ProfileCard
				name={name}
				open={open}
				handleClick={() => {
					setOpen(!open);
				}}
			/>
			<NavMenu label="Profile, Help, and Sign Out" open={open}>
				<ProfileLinks links={links} />
			</NavMenu>
		</ProfileWrapper>
	);
};

export default styled(ProfileDropdown)``;
